/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import KeycloakUsers from '../views/keycloak/keycloakUsers';
import { Box, Grid } from '@mui/material';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import KeycloakUserCreation from '../views/keycloak/keycloakUserCreation';
import KeycloakUserCount from '../views/keycloak/keycloakUserCount';
import KeycloakDBConnection from '../views/keycloak/keycloakDBConnection';

const ManagekeycloakPage = () => {
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Keycloak Users'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6}>
                        <span >

                            <KeycloakUserCreation />
                        </span>
                        <Box>
                            <KeycloakDBConnection />
                        </Box>
                        <KeycloakUserCount />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <KeycloakUsers />
                    </Grid>
                </Grid>
            </Box>

        </>
    )
}

export default ManagekeycloakPage;